import { Skeleton } from '@/_components/ui/skeleton'
import type { WithAuthComponentProps } from '@/_hocs/with-auth'
import { WithAuth } from '@/_hocs/with-auth'
import { Container } from '@/features/_components/ui/container'
import { useCompanyContext } from '@/features/_contexts/company-context'
import { useFacilityContext } from '@/features/_contexts/facility-context'
import { FacilityHeader } from '../../../_components/facility-header'
import { FacilityHeaderLoading } from '../../../_components/facility-header-loading'
import { FacilitySettingsForm } from './_components/facility-settings-form'
import { EditProvider } from './_providers/edit'
import { FormProvider } from './_providers/form-provider'

const FacilitySettings = ({ session }: WithAuthComponentProps) => {
  const company = useCompanyContext()
  const facility = useFacilityContext()
  const isStaff = session.user.userType === 'staff'

  if (!company || !facility) {
    return (
      <Container className="px-14 py-10 gap-6">
        <FacilityHeaderLoading />
        <div className="flex flex-col gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-12 w-full rounded-md" />
          ))}
        </div>
      </Container>
    )
  }

  return (
    <EditProvider>
      <FormProvider facility={facility}>
        <Container className="px-14 py-10 gap-6">
          <FacilityHeader
            company={company}
            facility={facility}
            backHref={`/companies/${company.slug}/facilities`}
            breadcrumbs={
              isStaff
                ? [
                    { label: 'Empresas', href: '/companies' },
                    { label: company.name, href: `/companies/${company.slug}/facilities` },
                    { label: facility.name },
                  ]
                : [
                    { label: 'Sua Instituição', href: `/companies/${company.slug}/facilities` },
                    { label: facility.name },
                  ]
            }
          />
          <FacilitySettingsForm facility={facility} canEdit={isStaff} />
        </Container>
      </FormProvider>
    </EditProvider>
  )
}

export default WithAuth(FacilitySettings, { allowedFor: ['staff', 'tenant'] })
